export const VPFollowersStatus = {
  PENDING: 1,
  ACCEPT: 2,
  REJECT: 3,
  WAITING_FOR_APPROVAL: 4,
};

export const VPFollowersPermissionType = {
  PUBLIC: 1,
  PRIVATE: 2,
};
const SubscriptionPlan = {
  Unknown: -1,
  New: 0,
  Free: 1,
  Premium: 2,
  Executive: 3,
};

export { SubscriptionPlan };
